import { useSelector } from 'react-redux';

import {
  selectCartGroupOrderCartClosed,
  selectIsGroupOrderCurrentDinerDoneOrdering
} from 'bento-ordering/cart/selectors/index';
import useIsGroupOrderGuestDiner from 'bento-ordering/group_ordering/hooks/useIsGroupOrderGuestDiner';

const useDisableCartButtonsForGroupOrderGuest = () => {
  const isGroupOrderCurrentDinerGuest = useIsGroupOrderGuestDiner();
  const isGroupOrderCartClosed = useSelector(selectCartGroupOrderCartClosed);
  const isGroupOrderCurrentDinerDoneOrdering = useSelector(
    selectIsGroupOrderCurrentDinerDoneOrdering
  );

  const disableCartButtons =
    isGroupOrderCurrentDinerGuest &&
    (isGroupOrderCartClosed || isGroupOrderCurrentDinerDoneOrdering);

  return disableCartButtons;
};

export default useDisableCartButtonsForGroupOrderGuest;
